import axios from "axios";
import {
  GET_SOLDE_SUCCESS,
  GET_SOLDE_LOAD,
  GET_SOLDE_FAILED,
} from "../constants/Solde";

export const getallSolde = () => async (dispatch) => {
  const config = {
    headers: {
      authorization: localStorage.getItem("token"),
    },
  };
  dispatch({ type: GET_SOLDE_LOAD });

  try {
    let results = await axios.get("/api/solde/soldes", config);
    // if i send an http request result bech tekho objet { status , headers ,data li jet mel api }
    dispatch({
      type: GET_SOLDE_SUCCESS,
      payload: results.data, // (hedhy tji feha un objet fih msg w EVENT)
    });
  } catch (error) {
    dispatch({ type: GET_SOLDE_FAILED });
    console.log(error);
  }
};
export const addSolde = (solde, history) => async (dispatch) => {
  const config = {
    headers: {
      authorization: localStorage.getItem("token"),
    },
  };
  dispatch({ type: GET_SOLDE_LOAD });
  try {
    await axios.post("/api/solde", solde, config);
    // dispatch({ type: SUCCESS });
    dispatch(getallSolde());

    history.push("/Factures");
  } catch (error) {
    dispatch({ type: GET_SOLDE_FAILED });
    console.log(error);
  }
};
export const deleteSolde = (id) => async (dispatch) => {
  dispatch({ type: GET_SOLDE_LOAD });
  try {
    await axios.delete(`/api/solde/${id}`);
    dispatch(getallSolde());
  } catch (error) {
    dispatch({ type: GET_SOLDE_FAILED });
    console.log(error);
  }
};
